import { __get__, __count__, __getAll__ } from './db';

function get(params: StorageGetParams): Promise<any> {
    return new Promise<any>(async (resolve, reject): Promise<any> => {
        let result: Array<any> = await __get__(params.tableName, params.query);

        resolve(result);
    });
}

function count(tableName: string): Promise<any> {
    return __count__(tableName);
}

function getAll(tableName: string): Promise<any> {
    return __getAll__(tableName);
}

export {
    get,
    count,
    getAll
};
